import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { GraduationCap, Menu, X } from "lucide-react";

const LINKS = [
  { label: "Home", href: "#home" },
  { label: "Destinations", href: "#destinations" },
  { label: "Services", href: "#services" },
  { label: "Why Us", href: "#why" },
  { label: "About", href: "#about" },
  { label: "Contact", href: "#contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? "backdrop-blur-xl bg-white/85 border-b border-gold/20 shadow-sm" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 md:px-10 h-20 flex items-center justify-between">
        <a href="#home" data-testid="nav-logo" className="flex items-center gap-2.5 group">
          <span className="grid place-items-center w-10 h-10 rounded-xl bg-navy text-gold shadow-md group-hover:rotate-6 transition-transform">
            <GraduationCap className="w-6 h-6" />
          </span>
          <span className="leading-none">
            <span className={`block font-display font-extrabold text-xl tracking-tight ${scrolled ? "text-navy" : "text-white"}`}>
              INVICTA <span className="text-gold">Overseas</span>
            </span>
            <span className={`block text-[10px] tracking-[0.25em] uppercase ${scrolled ? "text-navy/60" : "text-white/70"}`}>
              Educational Consultancy
            </span>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(" ", "-")}`}
              className={`text-sm font-semibold transition-colors hover:text-gold ${scrolled ? "text-navy/80" : "text-white/90"}`}
            >
              {l.label}
            </a>
          ))}
          <a
            href="#enquiry"
            data-testid="nav-cta"
            className="rounded-full bg-gold hover:bg-gold-dark text-white px-5 py-2.5 text-sm font-bold shadow-lg shadow-gold/30 active:scale-95 transition-all"
          >
            Free Consultation
          </a>
          <Link to="/admin/login" data-testid="nav-admin" className={`text-xs font-medium ${scrolled ? "text-navy/40" : "text-white/50"} hover:text-gold`}>
            Admin
          </Link>
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen(!open)}
          className={`lg:hidden ${scrolled ? "text-navy" : "text-white"}`}
        >
          {open ? <X className="w-7 h-7" /> : <Menu className="w-7 h-7" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-white border-t border-gold/20 px-5 py-4 space-y-1 shadow-xl">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="block py-2.5 text-navy font-semibold"
            >
              {l.label}
            </a>
          ))}
          <a href="#enquiry" onClick={() => setOpen(false)} className="block mt-2 rounded-full bg-gold text-white px-5 py-3 text-center font-bold">
            Free Consultation
          </a>
          <Link to="/admin/login" className="block py-2 text-sm text-navy/50">Admin Login</Link>
        </div>
      )}
    </header>
  );
}
